// extracted by mini-css-extract-plugin
export default {"contain":"Jogs5DRVEGzBZIVeLFNB","stretch":"d3MJvxw3Tsq3gUEYmZL9","header":"r93Lck9ra1AAX0Y6eINg","cell":"ZwrgLOsOlJJ750ISMAUi"};